<template>
	<div class="qzfooter" id="qzfooter" style="position: relative">
		<div
			style="display: flex;justify-content: space-between;width: 100%;padding: 0 0.3rem;box-sizing: border-box;margin-top: 0.3125rem;align-items: flex-start;">
			<div style="
          color: #86a7f1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 0.15rem;
        ">
				<div>服务咨询电话</div>
				<div style="margin-top: 0.1125rem">0532-87831285<br>0532-87831282</div>
			</div>
			<div style="
          color: #86a7f1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 0.15rem;
        ">
				<div>研学咨询电话</div>
				<div style="margin-top: 0.1125rem">0532-87836788</div>
			</div>
			<div style="
          color: #86a7f1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 0.15rem;
        ">
				<div>建议反馈电话</div>
				<div style="margin-top: 0.1125rem">0532-87831287</div>
			</div>
			<!--      <div
        style="
          flex: 0.5 1 0%;
          border-right: 1px solid #0e172a;
          color: #86a7f1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 0.225rem
        "
      >
        <div>公开投诉信箱</div>
        <div style="margin-top: 0.1125rem">qdkjg@qd.shandong.cn</div>
      </div> -->
			<!-- <div style="display: flex; flex: 0 0 2rem"> -->
			<!--        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 45px;
          "
        >
          <div
            style="
              width: 106px;
              height: 106px;
              background: #ffffff;
              margin-bottom: 16px;
            "
          ></div>
          <div style="color: #86a7f1">微信公众号</div>
        </div> -->
			<!--        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 45px;
          "
        >
          <div
            style="
              width: 106px;
              height: 106px;
              background: #ffffff;
              margin-bottom: 16px;
            "
          ></div>
          <div style="color: #86a7f1">微信小程序</div>
        </div> -->
			<!-- </div> -->
		</div>
		<div style="display: flex;flex-direction: column;align-items: center;margin-top: 0.4875rem;">
			<!-- <div style="width: 1.0625rem;height: 1.0625rem;background:#fff;margin-bottom: 0.15rem;">
      </div> -->
			<img src="../assets/image/code.png" style="width: 1.0625rem;height: 1.0625rem;margin-bottom: 0.15rem;">
			<div style="color: #86a7f1">青岛科技馆</div>
		</div>
		<div>
			<div style="
          color: #86a7f1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          font-size: 0.15rem;
        ">
				<div style="margin-top: 0.04rem;margin-bottom: 0.02rem; font-size: 0.15rem;">公开投诉信箱</div>
				<div style="margin-top: 0.04rem;margin-bottom: 0.125rem; font-size: 0.15rem;">qdstm@akzh.com.cn</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;margin-bottom:0.23rem">
			<span
				style="display:inline-block;text-align:center;padding:0 0.15rem;height: 0.3rem;line-height: 0.29rem;background: #273759;border-radius: 0.22rem;font-size: 0.135rem;font-family: Microsoft YaHei;font-weight: bold;color: #CFD4DD;">
				访问量：{{count}}
			</span>
		</div>
		<div style="text-align: center;height: 1.4rem;line-height: 0.3rem;border-top:1px solid #273654;width: 120.00048%;transform-origin:0 0;
font-size: 0.125rem;
transform: scale(0.83333);
font-family: Microsoft YaHei;
color: #86A7F1;">
			<div>
				Copyright © 2010-2023 青岛科技馆，<a style="text-decoration: none; color: #86A7F1" href="https://beian.miit.gov.cn/"
					target="_blank">鲁ICP备2023014219号</a>

			</div>
      <div style="display: flex; align-items: center; justify-content: center; gap: 0.05rem; ">

<img style="width: 0.18rem;  height: 0.18rem;" src="../assets/image/beian-icon.png" alt="">
<span>鲁公网安备37021402002763号</span>
</div>
		</div>

	</div>
</template>

<script>
import Cookies from "js-cookie";
import {
	getInfo,
	getcontenconnecconfigure,
	viewCount
} from "@/api/index/index.js";
export default {
	name: "app",
	data() {
		return {
			count: 0,
			linkList: [],
			menuList1: [{
				name: "首页",
				src: "Index",
			},
			{
				name: "科技馆概况",
				src: "Overview",
			},
			{
				name: "展览导航",
				src: "Navigation",
			},
			{
				name: "科普知识",
				src: "Knowledge",
			},
			],
			menuList2: [{
				name: "信息资讯",
				src: "Information",
			},
			{
				name: "服务咨询",
				src: "Consult",
			},
			{
				name: "展教活动",
				src: "EduInform",
			},
			{
				name: "特效影院",
				src: "Cinema",
			},
			],
		};
	},
	created() {
		this.getLinkInfo()
		this.viewCount()
	},
  	mounted() {
		var appElement = document.getElementById("qzfooter");

		// 创建一个新的span元素
		var spanElement = document.createElement("span");
		spanElement.id = "_ideConac";

		// 创建一个新的script元素
		var scriptElement = document.createElement("script");
		scriptElement.src =
			"https://dcs.conac.cn/js/16/235/0000/60265419/CA162350000602654190001.js";
		scriptElement.type = "text/javascript";

		// 将span元素和script元素插入到id为'app'的元素中
		appElement.appendChild(spanElement);
		appElement.appendChild(scriptElement);
	},
	methods: {
		viewCount() {
			viewCount().then(res => {
				if (res.data.code == 0) {
					this.count = res.data.count
					localStorage.setItem('count', this.count)
				}
			})
		},
		getLinkInfo() {
			getcontenconnecconfigure().then((res) => {
				let linkList = res.data.list;
				linkList.forEach((item) => {
					if (item.picture) {
						item.picture = process.env.VUE_APP_IMG_URL + item.picture;
					}
				});
				this.linkList = linkList
			});
		},
		toClick(item, index) {
			if (item.id == 7 || item.id == 8) {
				if (Cookies.get("userInfoqd")) {
					if (!JSON.parse(Cookies.get("userInfoqd")).token) {
						this.$message.success("请先登录再操作");
						// setTimeout(()=>{
						this.$router.push("/login");
						// },1000)
					} else {
						this.activeIndex = index;
						this.$router.push({
							name: item.src
						});
					}
				} else {
					this.$message.success("请先登录再操作");
					// setTimeout(()=>{
					this.$router.push("/login");
					// },1000)
				}
			} else {
				this.activeIndex = index;
				this.$router.push({
					name: item.src
				});
			}
		},
		toLink(item) {
			// window.open(item.website);
		},
	},
};
</script>

<style lang="less" scoped>
ul li {
	line-height: 26px;
	cursor: pointer;
}

.qzfooter {
	display: flex;
	flex-direction: column;
	width: 100%;
	// height: 5rem;
	background: #091022;
	// padding-bottom: 0.3375rem;s
}

.qzfooter0 {
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: 0.325rem 0 0.325rem;
	border-bottom: 1px solid #134098;
}

.qzfooter0 ul li {
	padding-right: 0.375rem;
	font-size: 0.175rem;
}

.qzfooter0 ul li a {
	color: #7f9ddd;
}

.qzfooter1 {
	display: flex;
	align-items: center;
	flex: 0 0 2.5rem;
	// height: 2.5rem;
	padding: 0.5rem 0;
	width: 21.5rem;
	margin: 0 auto;
	padding-left: 0.5rem;
	// padding-right: 136px;
	// padding-left: 191px;
	box-sizing: border-box;
	// border-bottom: 1px solid #0e172a;
}

.qzfooter2 {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;
	height: 2.5rem;
	font-size: 0.225rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #223853;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileFooter.vue